var map = {
	"./de/blogPosts/ai-2024-transcribing-tool-review-de.json": 82634,
	"./de/blogPosts/taption-feature-1-de.json": 63746,
	"./en/blogPosts/affiliate-terms-en.json": 26473,
	"./en/blogPosts/ai-2024-transcribing-tool-review-en.json": 77555,
	"./en/blogPosts/design-rush-interview-en.json": 80556,
	"./en/blogPosts/english-to-chinese-en.json": 63978,
	"./en/blogPosts/english-to-japanese-en.json": 44719,
	"./en/blogPosts/english-to-korean-en.json": 53257,
	"./en/blogPosts/english-to-vietnamese-en.json": 30344,
	"./en/blogPosts/taption-ai-sub-ai-analysis-en.json": 97821,
	"./en/blogPosts/taption-feature-1-en.json": 66565,
	"./en/blogPosts/transcript-timeline-syncing-en.json": 17214,
	"./en/blogPosts/webex-tutorial-en.json": 29972,
	"./en/blogPosts/zoom-tutorial-en.json": 59436,
	"./es/blogPosts/ai-2024-transcribing-tool-review-es.json": 75367,
	"./es/blogPosts/taption-feature-1-es.json": 60014,
	"./fr/blogPosts/ai-2024-transcribing-tool-review-fr.json": 5475,
	"./fr/blogPosts/taption-feature-1-fr.json": 31322,
	"./id/blogPosts/ai-2024-transcribing-tool-review-id.json": 48087,
	"./id/blogPosts/taption-feature-1-id.json": 6280,
	"./jp/blogPosts/ai-2024-transcribing-tool-review-jp.json": 42227,
	"./jp/blogPosts/taption-feature-1-jp.json": 53199,
	"./kr/blogPosts/ai-2024-transcribing-tool-review-kr.json": 75294,
	"./kr/blogPosts/taption-feature-1-kr.json": 35184,
	"./pt/blogPosts/ai-2024-transcribing-tool-review-pt.json": 29653,
	"./pt/blogPosts/taption-feature-1-pt.json": 91477,
	"./zh/blogPosts/ai-2024-transcribing-tool-review-zh.json": 72874,
	"./zh/blogPosts/chinese-to-english-zh.json": 51443,
	"./zh/blogPosts/chinese-to-japanese-zh.json": 2542,
	"./zh/blogPosts/chinese-to-korean-zh.json": 77627,
	"./zh/blogPosts/chinese-to-vietnamese-zh.json": 45348,
	"./zh/blogPosts/taption-ai-sub-ai-analysis-zh.json": 45377,
	"./zh/blogPosts/taption-feature-1-zh.json": 72804,
	"./zh/blogPosts/taption-feature-2-zh.json": 59907,
	"./zh/blogPosts/taption-feature-3-zh.json": 41560,
	"./zh/blogPosts/taption-introduction-zh.json": 38005,
	"./zh/blogPosts/translation-memory-zh.json": 37934,
	"./zh/blogPosts/webex-tutorial-zh.json": 38559,
	"./zh/blogPosts/zoom-tutorial-zh.json": 5293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18996;